// Resolves a URL and returns it only if it is http(s); rejects javascript:, data:, etc.
// Without a base (e.g. outside the browser), relative URLs resolve to null.
export function resolveHttpUrl(
  url: string | null | undefined,
  base: string | undefined = globalThis.location?.origin
): string | null {
  const trimmed = url?.trim();
  if (!trimmed) return null;
  try {
    const parsed = new URL(trimmed, base);
    if (parsed.protocol === "https:" || parsed.protocol === "http:") {
      return parsed.href;
    }
  } catch {
    // unparseable URL
  }
  return null;
}

// Like resolveHttpUrl, but also allows inline data:image/ URIs (safe in <img src>).
export function resolveImageUrl(url: string | null | undefined): string | null {
  const trimmed = url?.trim();
  if (trimmed && /^data:image\//i.test(trimmed)) return trimmed;
  return resolveHttpUrl(trimmed);
}
